(function () {
    'use strict';
    var m = angular.module('app');
    m.provider('routerV2Service', [
        '$routeProvider',
        function ($routeProvider) {
            this.specials = function () {
                return $routeProvider.when('/loadPage/:loadPageUrl*', {
                    name: 'dashboard',
                    resolve: {
                        init: ["$route", function ($route) {
                            var loadPageUrl = $route.current.params.loadPageUrl;
                            var origin = window.origin;
                            var completeUrl = origin + '/' + loadPageUrl;
                            window.location.href = completeUrl;
                        }]
                    }
                });
            };
            this.routers = function (utils, resolvers) {
                return $routeProvider.when('/', {
                    templateUrl: utils.templatePath('gui-v2', 'dashboard-v2'),
                    controller: 'DashboardControllerV2',
                    title: 'Dashboard',
                    name: 'dashboard',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/policy-rules', {
                    templateUrl: utils.templatePath('gui-v2', 'policy-rules'),
                    controller: 'PolicyRulesController',
                    title: 'Policy',
                    name: 'policy-rules',
                    reloadOnSearch: false,
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/policy/add-rule', {
                    templateUrl: utils.templatePath('gui-v2', 'policy-rule-edit'),
                    controller: 'PolicyRuleEditController',
                    title: 'Policy',
                    name: 'policy-rule-add',
                    mode: 'create',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/policy/edit-rule/:id', {
                    templateUrl: utils.templatePath('gui-v2', 'policy-rule-edit'),
                    controller: 'PolicyRuleEditController',
                    title: 'Policy',
                    name: 'policy-rule-edit',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/app-store', {
                    templateUrl: utils.templatePath('gui-v2', 'app-store-v2'),
                    controller: 'AppStoreV2Controller',
                    title: 'Applications Store',
                    themeTitle: { avananTheme: 'Security Engines' },
                    name: 'app-store',
                    accessor: 'appStore',
                    resolve: { currentUser: resolvers.currentUser },
                    roles: [
                        'admin',
                        'user'
                    ]
                }).when('/cloud-apps', {
                    templateUrl: utils.templatePath('gui-v2', 'app-store-v2'),
                    controller: 'AppStoreV2Controller',
                    title: 'Cloud Store',
                    themeTitle: { avananTheme: 'SaaS Apps' },
                    name: 'cloud-apps',
                    accessor: 'cloudApps',
                    resolve: { currentUser: resolvers.currentUser },
                    roles: [
                        'admin',
                        'user'
                    ]
                }).when('/security-events', {
                    templateUrl: utils.templatePath('gui-v2', 'security-events'),
                    controller: 'SecurityEventsController',
                    title: 'Events',
                    name: 'security-events',
                    reloadOnSearch: false,
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/quarantine/:module', {
                    templateUrl: utils.templatePath('gui-v2', 'quarantine-v2'),
                    controller: 'QuarantineControllerV2',
                    title: 'Quarantine',
                    name: 'quarantine',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/restore-requests/:module', {
                    templateUrl: utils.templatePath('gui-v2', 'restore-requests'),
                    controller: 'RestoreRequestsController',
                    title: 'Restore Requests',
                    name: 'restore-requests',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/report-phishing/:module', {
                    templateUrl: utils.templatePath('gui-v2', 'report-phishing'),
                    controller: 'ReportPhishingController',
                    title: 'User Reported Phishing',
                    name: 'report-phishing',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/threat-extracted-emails/:module', {
                    templateUrl: utils.templatePath('gui-v2', 'threat-extracted-emails'),
                    controller: 'ThreatExtractedEmailsController',
                    title: 'Threat Extracted Emails',
                    name: 'threat-extracted-emails',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/extracted-restore-requests/:module', {
                    templateUrl: utils.templatePath('gui-v2', 'extracted-restore-requests'),
                    controller: 'ExtractedRestoreRequestsController',
                    title: 'Extracted Restore Requests',
                    name: 'extracted-restore-requests',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/authorize-success', {
                    templateUrl: utils.templatePath('auth', 'authorize-error'),
                    controller: 'AuthorizeErrorController',
                    title: utils.title('Successful Service Authorization'),
                    name: 'authorize-error',
                    resolve: { featureResolver: resolvers.featureResolver },
                    fullscreen: true
                }).when('/authorize-error', {
                    templateUrl: utils.templatePath('auth', 'authorize-error'),
                    controller: 'AuthorizeErrorController',
                    title: utils.title('Service Authorization Error'),
                    name: 'authorize-error',
                    resolve: { featureResolver: resolvers.featureResolver },
                    fullscreen: true,
                    scrollOnPage: true
                }).when('/configuration', {
                    templateUrl: utils.templatePath('example', 'example'),
                    controller: 'ExampleController',
                    title: 'Configuration',
                    name: 'configuration',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/settings', {
                    templateUrl: utils.templatePath('settings', 'settings', 'settings-v2'),
                    controller: 'SettingsController',
                    title: 'Settings',
                    name: 'settings',
                    resolve: { currentUser: resolvers.currentUser },
                    roles: [
                        'admin',
                        'user'
                    ]
                }).when('/wizard', {
                    templateUrl: utils.templatePath('gui-v2', 'wizard-v2'),
                    controller: 'WizardControllerV2',
                    title: 'Wizard',
                    name: 'wizard',
                    resolve: { currentUser: resolvers.currentUser },
                    fullscreen: true
                }).when('/email-domains', {
                    templateUrl: utils.templatePath('settings', 'email-domains'),
                    controller: 'EmailDomainsController',
                    title: utils.title('Email Domains Management'),
                    name: 'email-domains',
                    resolve: { currentUser: resolvers.currentUser },
                    scrollOnPage: true
                }).when('/user-management', {
                    templateUrl: utils.templatePath('gui-v2', 'user-list-v2'),
                    controller: 'UserListControllerV2',
                    title: utils.title('User management'),
                    name: 'user-management',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    roles: ['admin']
                }).when('/wizard-user-management', {
                    templateUrl: utils.templatePath('gui-v2', 'user-list-v2'),
                    controller: 'UserListControllerV2',
                    title: utils.title('User management'),
                    name: 'wizard-user-management',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    fullscreen: true,
                    roles: ['admin']
                }).when('/security-stack', {
                    templateUrl: utils.templatePath('gui-v2', 'security-stack-v2'),
                    controller: 'SecurityStackV2Controller',
                    title: 'Security stack',
                    name: 'security-stack',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/sec-app-stats', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'SecAppStatsController',
                    title: utils.title('Security applications statistics'),
                    name: 'sec-app-stats',
                    resolve: { currentUser: resolvers.currentUser },
                    scrollOnPage: true
                }).when('/main-queue-stats', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'MainQueueStatsController',
                    title: utils.title('Main queue statistics'),
                    name: 'main-queue-stats',
                    resolve: { currentUser: resolvers.currentUser },
                    scrollOnPage: true
                }).when('/download-history', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'DownloadHistoryController',
                    title: utils.title('Download History'),
                    name: 'download-history',
                    resolve: { currentUser: resolvers.currentUser },
                    scrollOnPage: true
                }).when('/entity-trend', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EntityTrendController',
                    title: utils.title('Entity trend'),
                    name: 'entity-trend',
                    resolve: { currentUser: resolvers.currentUser },
                    scrollOnPage: true
                }).when('/entity-per-user', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EntityPerUserController',
                    title: utils.title('Entity per user'),
                    name: 'entity-per-user',
                    resolve: { currentUser: resolvers.currentUser },
                    scrollOnPage: true
                }).when('/health-check', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'HealthCheckController',
                    title: utils.title('Health Status'),
                    name: 'health-check',
                    resolve: { currentUser: resolvers.currentUser },
                    addStandardPage: true
                }).when('/scan-monitor', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'ScanMonitorController',
                    title: utils.title('Scanning status'),
                    name: 'scan-monitor',
                    resolve: { currentUser: resolvers.currentUser },
                    addStandardPage: true
                }).when('/licenses', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'LicensesController',
                    title: utils.title('Licenses status'),
                    name: 'licenses',
                    resolve: { currentUser: resolvers.currentUser },
                    addStandardPage: true
                }).when('/learning-mode-state', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'LearningModeStateController',
                    title: utils.title('Learning mode state'),
                    name: 'learning-mode-state',
                    resolve: { currentUser: resolvers.currentUser },
                    addStandardPage: true
                }).when('/inline-messages/:module/', {
                    templateUrl: utils.templatePath('troubleshooting', 'inline-messages'),
                    controller: 'InlineMessagesController',
                    title: utils.title('Inline messages'),
                    name: 'inline-messages',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    addStandardPage: true
                }).when('/viewer/:module/:id', {
                    templateUrl: utils.templatePath('viewer', 'viewer'),
                    controller: 'ViewerController',
                    title: utils.title('Viewer'),
                    name: 'viewer',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    addStandardPage: true
                }).when('/system-config', {
                    templateUrl: utils.templatePath('settings', 'system-config'),
                    controller: 'SystemConfigController',
                    title: utils.title('System Configuration'),
                    name: 'system-config',
                    resolve: { currentUser: resolvers.currentUser },
                    addStandardPage: true
                }).when('/password-change', {
                    templateUrl: utils.templatePath('gui-v2', 'password-change-v2'),
                    controller: 'PasswordChangeControllerV2',
                    title: utils.title('Change Password'),
                    name: 'password-change',
                    fullscreen: true
                }).when('/auth/:page', {
                    templateUrl: utils.templatePath('gui-v2', 'auth-v2'),
                    controller: 'AuthControllerV2',
                    title: utils.title('Login'),
                    name: 'auth',
                    fullscreen: true,
                    resolve: {
                        userNotExist: resolvers.userNotExist,
                        featureResolver: resolvers.featureResolver
                    }
                }).when('/login', { redirectTo: '/auth/login' }).when('/password-reset', { redirectTo: '/auth/password-reset' }).when('/profile/:entityType/:id*', {
                    templateUrl: utils.templatePath('gui-v2', 'profile-v2'),
                    controller: 'ProfileControllerV2',
                    title: 'Profile',
                    name: 'profile',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/email-restore/:module/:msg', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'EmailRestoreController',
                    title: utils.title('Email restore'),
                    name: 'email-restore',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/policy', {
                    templateUrl: utils.templatePath('policy', 'policy-list'),
                    controller: 'PolicyListController',
                    title: utils.title('Analytics'),
                    name: 'policy-list',
                    resolve: { currentUser: resolvers.currentUser },
                    hideSystemPolicies: true
                }).when('/policy/create/:saas?', {
                    templateUrl: utils.templatePath('policy', 'policy-create'),
                    controller: 'PolicyCreateController',
                    title: utils.title('Query create'),
                    name: 'policy-create',
                    resolve: { currentUser: resolvers.currentUser },
                    internalModuleChange: false,
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/query/create/:saas?', {
                    // add query create route with 'Query' title
                    templateUrl: utils.templatePath('policy', 'policy-create'),
                    controller: 'PolicyCreateController',
                    title: utils.title('Query'),
                    name: 'policy-create',
                    resolve: { currentUser: resolvers.currentUser },
                    internalModuleChange: false,
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/policy/edit/:id', {
                    templateUrl: utils.templatePath('policy', 'policy'),
                    controller: 'PolicyController',
                    title: utils.title('Query'),
                    name: 'policy-edit',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    hiddenOverflow: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/policy/edit/query/:id', {
                    templateUrl: utils.templatePath('policy', 'policy'),
                    controller: 'PolicyController',
                    title: utils.title('Query'),
                    name: 'policy-edit-query',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    hiddenOverflow: true,
                    noPaddings: true,
                    addStandardPage: true,
                    hideOriginStyle: true
                }).when('/system-log', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'SystemLogController',
                    title: utils.title('System Log'),
                    name: 'system-log',
                    resolve: { currentUser: resolvers.currentUser },
                    hideSaasSwitch: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/sec-tool-exceptions/:module/:type?', {
                    templateUrl: utils.templatePath('configuration', 'sec-tool-exceptions'),
                    controller: 'SecToolExceptionsController',
                    title: utils.title('Security Tools Exceptions'),
                    name: 'sec-tool-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/configuration/anomaly-exceptions', {
                    templateUrl: utils.templatePath('gui-v2', 'anomaly-exceptions'),
                    controller: 'AnomalyExceptionsV2Controller',
                    title: 'Anomaly Exceptions',
                    name: 'anomaly-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/ap-exceptions/:type?', {
                    templateUrl: utils.templatePath('configuration', 'ap-avanan-exceptions'),
                    controller: 'ApAvananExceptionsController',
                    title: utils.title('Anti-Phishing Allow-List'),
                    themeTitle: { sonicwallTheme: utils.title('Anti-Phishing Exceptions') },
                    name: 'ap-avanan-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/configuration/solgate-exceptions', {
                    templateUrl: utils.templatePath('configuration', 'solgate-exceptions'),
                    controller: 'SolgateExceptionsController',
                    title: utils.title('Solgate Exceptions'),
                    name: 'solgate-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    hideSaasSwitch: true,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/configuration/security-exceptions', {
                    templateUrl: utils.templatePath('gui-v2', 'security-exceptions'),
                    controller: 'SecurityExceptionsController',
                    title: 'Security Events Exceptions',
                    name: 'security-exceptions',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/ap-blacklist', {
                    templateUrl: utils.templatePath('configuration', 'ap-avanan-blacklist'),
                    controller: 'ApAvananBlacklistController',
                    title: 'Anti-Phishing Block-List',
                    name: 'ap-avanan-blacklist',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/clicktime-protection-list-management', {
                    templateUrl: utils.templatePath('gui-v2', 'clicktime-protection-list-management'),
                    controller: 'ClicktimeProtectionListManagementController',
                    title: 'ClickTime Protection Exceptions',
                    name: 'clicktime-protection-list-management',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/configuration/license-configuration/:module', {
                    templateUrl: utils.templatePath('gui-v2', 'licenses'),
                    controller: 'LicenseConfigurationController',
                    title: 'License Configuration',
                    name: 'license-configuration',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/inline-debug/:module/', {
                    templateUrl: utils.templatePath('troubleshooting', 'inline-debug'),
                    controller: 'InlineDebugController',
                    title: utils.title('Inline Emergency Options'),
                    name: 'inline-debug',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    noPaddings: true,
                    addStandardPage: true
                }).when('/ip/:module/:id*', {
                    templateUrl: utils.templatePath('dashboard', 'dashboard'),
                    controller: 'IpProfileController',
                    title: utils.title('IP profile'),
                    name: 'ip',
                    resolve: { currentUser: resolvers.currentUser },
                    addStandardPage: true
                }).when('/analytics/summary-report', {
                    templateUrl: utils.templatePath('gui-v2', 'summary-report-v2'),
                    controller: 'SummaryReportV2Controller',
                    title: 'Summary Report',
                    name: 'summary-report',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/analytics/shadow_it', {
                    templateUrl: utils.templatePath('gui-v2', 'shadow-it-v2'),
                    controller: 'ShadowItControllerV2',
                    title: 'Shadow IT',
                    themeTitle: { sonicwallTheme: 'Shadow SaaS' },
                    name: 'shadow-it',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/analytics/shadow_it/:app', {
                    templateUrl: utils.templatePath('gui-v2', 'shadow-it-v2'),
                    controller: 'ShadowItControllerV2',
                    title: 'Shadow IT',
                    themeTitle: { sonicwallTheme: 'Shadow SaaS' },
                    name: 'shadow-it-per-app',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/analytics/ms_azure', {
                    templateUrl: utils.templatePath('gui-v2', 'azure-dashboard'),
                    controller: 'AzureDashboardController',
                    title: 'Azure Dashboard',
                    name: 'azure-dashboard',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/analytics/phishing', {
                    templateUrl: utils.templatePath('gui-v2', 'phishing-dashboard'),
                    controller: 'PhishingDashboardController',
                    title: 'Phishing Dashboard',
                    name: 'phishing-dashboard',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/analytics/weekly-reports', {
                    templateUrl: utils.templatePath('gui-v2', 'weekly-reports'),
                    controller: 'WeeklyReportsController',
                    title: 'Periodic Reports',
                    name: 'weekly-reports',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/analytics/:page/', {
                    templateUrl: utils.templatePath('gui-v2', 'analytics'),
                    controller: 'AnalyticsController',
                    title: '',
                    name: 'analytics',
                    resolve: { currentUser: resolvers.currentUser }
                }).when('/drive-explorer/:module', {
                    templateUrl: utils.templatePath('advanced-data-search', 'advanced-data-search'),
                    controller: 'AdvancedDataSearchController',
                    title: utils.title('Drive explorer'),
                    name: 'drive-explorer',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    addStandardPage: true
                })    // .when('/mail-explorer/:module', {
                      //     templateUrl: utils.templatePath('advanced-data-search', 'mail-explorer'),
                      //     controller: 'MailExplorer',
                      //     title: utils.title('Mail Explorer'),
                      //     name: 'mail-explorer',
                      //     resolve: { currentUser: resolvers.currentUser },
                      //     reloadOnSearch: false,
                      //     addStandardPage: true
                      // })
                      // this is redirecting mail-explorer to the policy-catalog special template
.when('/mail-explorer/:module', {
                    templateUrl: utils.templatePath('advanced-data-search', 'mail-explorer-old'),
                    controller: 'MailExplorerOld',
                    title: utils.title('Mail Explorer'),
                    name: 'mail-explorer',
                    resolve: {
                        currentUser: resolvers.currentUser,
                        options: _.constant({ mode: 'page' })
                    },
                    reloadOnSearch: false,
                    addStandardPage: true
                }).when('/mail-explorer-new', {
                    templateUrl: utils.templatePath('advanced-data-search', 'mail-explorer-new'),
                    controller: 'MailExplorerNew',
                    title: utils.title('Mail Explorer'),
                    name: 'mail-explorer-new',
                    resolve: {
                        currentUser: resolvers.currentUser,
                        options: _.constant({ mode: 'page' })
                    },
                    reloadOnSearch: false,
                    addStandardPage: true
                }).when('/shadow-it-apps', {
                    templateUrl: utils.templatePath('gui-v2', 'shadow-it-apps'),
                    controller: 'ShadowItAppsController',
                    title: utils.title('Shadow IT Applications'),
                    themeTitle: { sonicwallTheme: 'Shadow SaaS Applications' },
                    name: 'shadow-it-apps',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/anti-phishing-settings', {
                    templateUrl: utils.templatePath('gui-v2', 'anti-phishing-settings'),
                    controller: 'AntiPhishingSettingsController',
                    title: 'Anti Phishing Settings',
                    name: 'anti-phishing-settings',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false,
                    roles: [
                        'admin',
                        'user',
                        'operations'
                    ]
                }).when('/system-tasks', {
                    templateUrl: utils.templatePath('gui-v2', 'system-tasks'),
                    controller: 'SystemTasksController',
                    title: 'System Tasks',
                    name: 'system-tasks',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/anomaly-detection-settings', {
                    templateUrl: utils.templatePath('gui-v2', 'anomaly-detection-settings'),
                    controller: 'AnomalyDetectionSettingsController',
                    title: 'Anomaly Detection Settings',
                    name: 'anomaly-detection-settings',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/configuration/clicktime-protection-settings', {
                    templateUrl: utils.templatePath('gui-v2', 'clicktime-protection-settings'),
                    controller: 'ClicktimeProtectionSettingsController',
                    title: 'ClickTime Protection Settings',
                    name: 'clicktime-protection-settings',
                    resolve: { currentUser: resolvers.currentUser },
                    reloadOnSearch: false
                }).when('/blank', {
                    templateUrl: utils.templatePath('gui-v2', 'blank'),
                    controller: 'BlankController',
                    title: 'Blank',
                    name: 'blank'
                }).otherwise({ redirectTo: '/' });
            };
            this.$get = [];
        }
    ]);
}());